import { FC, useEffect } from 'react'
import { useAlert } from 'react-alert'

import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import {
  removeAlertError,
} from '../../../states/containers/common/errorsSlice'
import { useTranslation } from 'react-i18next'

const ErrorAlert: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const alert = useAlert()

  const {
    errors,
  } = useSelector((state: RootState) => state)

  useEffect(() => {
    if (errors.alertErrors.length !== 1) return
    alert.error(t(`layouts.alert${errors.alertErrors[0].message}`), {
      timeout: 3000,
    })
    setTimeout(() => {
      dispatch(removeAlertError())
    }, 3000)
  }, [errors.alertErrors])

  return null
}

export default ErrorAlert
